import styled from "styled-components"

export const Modal = styled.aside`
  position: fixed;
  top: 16px;
  right: 0;
  height: calc(100vh - 32px);
  min-height: 100%;
  width: 700px;
  box-shadow: -8px 0 13px rgba(0, 0, 0, 0.45);
  background-color: #f2eeed;
  display: flex;
  align-items: center;
  justify-content: center;

  .simplebar-track {
    width: 2px;
    right: 38px;
    top: 1.5em;
    background: #dad2d2;
    overflow: visible;
  }
  .simplebar-scrollbar {
    width: 100%;
    right: 0;
    &::before {
      background: #df4a32;
      width: 5px;
      top: 0 !important;
      bottom: 0 !important;
      left: 50% !important;
      transform: translateX(-50%);
      border-radius: 0;
      opacity: 1 !important;
    }
  }

  @media (max-width: 768px) {
    height: calc(100vh - 100px);
    width: 100%;
    top: 100px;
    overflow: auto;
  }
`
export const ModalArticle = styled.article`
  height: 80vh;
  width: 80%;
  padding: 0 3%;
  margin: 0 auto;
  position: relative;

  @media (max-width: 768px) {
    height: 100%;
    margin-top: 30px;
    width: 100%;
    padding: 0;
    margin-bottom: 30px;
  }
`
export const ModalImage = styled.img`
  max-width: 100%;
  cursor: pointer;
`
export const ModalFigure = styled.figure`
  @media (max-width: 768px) {
    margin-left: 18px;
    margin-right: 18px;
  }
`
export const ModalFigcaption = styled.figcaption``
export const ModalIndex = styled.h6`
  color: #f2eeed;
  font-family: "Oswald", sans-serif;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 1.22px;
  line-height: 1.25em;
  position: absolute;
  top: 0;
  left: -30px;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    position: static;
  }
`
export const ModalHeadline = styled.h5`
  color: #23191c;
  font-family: "Oswald", sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0.08em;
  line-height: 1.25em;
  text-transform: uppercase;
  margin-bottom: 1em;
  margin-top: 0.5em;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-top: 80px;
    margin-left: 18px;
    margin-right: 18px;
  }
`
export const ModalContent = styled.div`
  color: #23191c;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  letter-spacing: 0.065em;
  line-height: 2em;
  margin-bottom: 50px;

  p {
    color: #23191c;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    letter-spacing: 0.065em;
    line-height: 2em;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 27px;
      margin-left: 18px;
      margin-right: 18px;
    }
  }
`
export const ModalAudio = styled.div`
  margin-top: 3em;

  @media (max-width: 768px) {
    margin-left: 18px;
    margin-right: 18px;
  }
`
export const ModalFullPage = styled.aside`
  position: fixed;
  top: 16px;
  left: 16px;
  height: calc(100vh - 32px);
  min-height: 100%;
  width: calc(100% - 32px);
  background-color: #f2eeed;
`
export const MapIndex = styled.p`
  color: #f2eeed;
  font-family: Oswald;
  font-size: 12px;
  letter-spacing: 0.7px;
  font-weight: 600;
`
export const ModalFullPageWrapper = styled.aside`
  width: 35%;
  margin: 5% auto;
  display: flex;
  flex-direction: column;
`
export const ModalFullPageContent = styled.aside`
  .simplebar-track {
    width: 2px;
    right: 38px;
    top: 1.5em;
    background: #dad2d2;
    overflow: visible;
  }
  .simplebar-scrollbar {
    width: 100%;
    right: 0;
    &::before {
      background: #df4a32;
      width: 5px;
      top: 0 !important;
      bottom: 0 !important;
      left: 50% !important;
      transform: translateX(-50%);
      border-radius: 0;
      opacity: 1 !important;
    }
  }
`
export const GalleryModalContainer = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  min-height: 100%;
  width: 100%;
  background-color: rgba(35,25,28,0.95);
`
export const GalleryModalFigure = styled.figure`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const GalleryModalImage = styled.img`
  max-height: 80vh;
`
export const GalleryModalFigcaption = styled.figcaption`
  color: #dad2d2;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1.28px;
  line-height: 32px;
  text-align: center;
  margin-top: 25px;
`
export const NextModalHeadlineWrapper = styled.div`
  align-self: center;
  position: relative;
  margin-top: 50px;
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`
export const NextModalIndex = styled.div`
  color: #f2eeed;
  font-family: "Oswald", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.7px;
  line-height: 1.25em;
  position: absolute;
  top: 0;
  left: -30px;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(0, -12%);

  @media (max-width: 768px) {
    position: static;
    margin-right: 7px;
  }
`
export const NextModalHeadline = styled.p`
  text-align: center;
  color: #23191c;
  font-family: "Oswald", sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.4px;
  line-height: 1.25em;
  text-transform: uppercase;
`
export const Tooltip = styled.div`
  color: #f2eeed;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.78px;
  line-height: 18px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 50px;
`
export const TooltipText = styled.p`
  display: inline;
`
export const MobileCloseModal = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #df4a32;
  position: fixed;
`